import React from 'react';
import { Text, ProgressBar, Checkbox } from '../../Atoms';
import { AffiliationRecapMolecule, AffiliationButtonMolecule } from '../../Molecules';

function OrganismAffiliationStage2(props) {
    return (
        <div className="organism-affilation-stage1-container">
            <Text text="Complétez votre affiliation" className="organism-affiliation-stage1-title" />
            <Text text="Afin de finaliser votre adhésion, merci de bien vouloir remplir les champs suivants :" className="organism-affiliation-stage1-description" />
            <Text text={`Etape ${props.stage} / 5`} className="organism-affiliation-stage1-stage" />
            <ProgressBar
                percent={`${(props.stage * 100 / 5).toString()}%`}
                height="15px"
                backgroundColor="#fff"
                backgroundColorFulFilled="#FF8AD8"
                containerClassName="organism-affiliation-stage1-progressBar"
            />
            <div >
                <div className="organism-affiliation-stage1-recap-container">
                    <AffiliationRecapMolecule />
                </div>
                <div className="organism-affiliation-form-container">
                    <Text text="Option" className="organism-affiliation-stage1-personal-info" />
                    <div className="organism-affiliation-stage2-description">Souhaitez-vous bénéficier d’une option pour <span>renforcer vos garanties</span> ? </div>
                    <div className="organism-affiliation-stage1-checkBox-container organism-affiliation-stage2-checkBox-container" >
                        <Checkbox
                            type="checkbox"
                            label="Oui, je prends l’option"
                            className="organism-affiliation-stage1-checkbox"
                            classNameContainer="organism-affiliation-checkbox-container"
                            size={13}
                            onClick={() => props.optionClicked(1)}
                            checked={props.option === 1}
                        />
                        <Checkbox
                            type="checkbox"
                            label="Non, je ne suis pas intéressé(e)"
                            className="organism-affiliation-stage1-checkbox"
                            classNameContainer="organism-affiliation-checkbox-container"
                            size={13}
                            onClick={(e) => props.optionClicked(0)}
                            checked={props.option === 0}
                        />
                    </div>
                </div>
            </div>
            <AffiliationButtonMolecule
                confirmerClicked={props.confirmerClicked}
                goBackClicked={props.goBackClicked}
            />
        </div>
    );
}

export default OrganismAffiliationStage2;
